import AddMeterDetails from "../../../../../presentation/pages/meters/add-meter/components/addMeterDetails";
import { makeValidateAddMeterDetailsValidation } from "./validate-add-meter-details-validation-factory";

export const makeAddMeterDetails = () => {
  return (
    <AddMeterDetails validation={makeValidateAddMeterDetailsValidation()} />
  );
};
